import React from 'react';
import { PropTypes } from 'prop-types';

import { findObjectInArray } from '../../../../../utils/filters';

import Input from '../../../../../components/input';

const StringInput = ({
  input, data, setData, errorsList, setInputInformation, key,
}) => {
  const {
    showTitleToUser, inputType, placeholder, propertyName,
    annotation,
  } = input;

  return (
    <Input
      key={key}
      label={showTitleToUser}
      placeholder={placeholder || ''}
      value={data[propertyName]}
      type={inputType === 'string' ? 'text' : inputType}
      onChange={(e) => setInputInformation(
        data, { propertyName, value: e }, setData)}
      annotation={annotation || ''}
      className="separation-input"
      annotationError={
        findObjectInArray(propertyName, errorsList, 'name')
          ? findObjectInArray(propertyName, errorsList, 'name').error
          : null
      }
    />
  );
};

StringInput.propTypes = {
  key: PropTypes.string.isRequired,
  input: PropTypes.shape().isRequired,
  data: PropTypes.shape().isRequired,
  setData: PropTypes.func.isRequired,
  errorsList: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  setInputInformation: PropTypes.func.isRequired,
};

export default (StringInput);
